var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wechat-moments-list" },
    [
      _c("CommonSOP", {
        attrs: {
          KHSOPxbc: _vm.KHSOPxbc,
          KHSOPcd: _vm.QFcd,
          namePlaceholder: "消息名称",
          tableData: _vm.tableData,
          tableHeader: _vm.tableHeader,
          pageparm: _vm.pageparm
        },
        on: {
          reGet: _vm.getData,
          createSOP: _vm.createSOP,
          handleDetail: _vm.handleDetail,
          handleData: _vm.handleData
        }
      }),
      _c("CommonSOPDetail", {
        attrs: { titleName: "新建群发", myType: 5, myVisiable: _vm.myVisiable },
        on: { reGet: _vm.getData, closeDialog: _vm.closeDialog }
      }),
      _c("DataDialog", {
        attrs: {
          isLoading: _vm.isLoading,
          KHSOPcd: _vm.QFcd,
          titleName: _vm.titleName,
          tableHeader: _vm.dataTableHeader,
          tableData: _vm.dataTableData,
          myVisiable: _vm.dataMyVisiable,
          pageparm: _vm.dataPageparm,
          myType: 3
        },
        on: {
          closeDialog: _vm.dataCloseDialog,
          reGet: _vm.reGet,
          handleExport: _vm.handleExport
        }
      }),
      _c("SopDetail", {
        attrs: {
          titleName: "群发详情",
          myType: 5,
          myVisiable: _vm.detailMyVisiable,
          detaildata: _vm.detailData
        },
        on: { closeDialog: _vm.closeDetailDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }